export default {
  data() {
    return {
      page: 1,
      perPage: 10,
      pages: [],
    };
  },
  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },

  watch: {
    filteredData() {
      this.setPages()
    }
  },

  methods: {
    setPages() {
      const data = Array.isArray(this.filteredData) ? this.filteredData : []
      const count = Math.ceil(data.length / this.perPage)
      this.pages = Array.from({ length: count }, (_, i) => i + 1)
    },

    paginate(data) {
      const start = (this.page - 1) * this.perPage
      const end = start + this.perPage
      return Array.isArray(data) ? data.slice(start, end) : []
    },

    truncateText(text, maxLength) {
      if (!text) return ''
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
    },

    onSort(column) {
      this.direction = this.direction === 'asc' ? 'desc' : 'asc';
      const sortedArray = [...this.data];
      sortedArray.sort((a, b) => {
        const res = a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0;
        return this.direction === 'asc' ? res : -res;
      });
      this.data = sortedArray;
    }
  }
};